import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_USER_PERMISSIONS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.CREATE_USER_PERMISSION:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_USER_PERMISSION:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_USER_PERMISSION:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
